(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cancel-order"] && !Shopify.designMode) return;
  try {
    
document.getElementById('cancel-order-button').addEventListener('click', function() {
  document.getElementById('issue-cancel-popup').classList.remove('hidden');
});

document.getElementById('close-cancel-popup').addEventListener('click', function() {
  document.getElementById('issue-cancel-popup').classList.add('hidden');
});

  document.getElementById('custom-coupon-code').addEventListener('click', function() {
    var couponCode = document.getElementById('coupon-code').textContent;
    navigator.clipboard.writeText(couponCode).then(function() {
        document.getElementById('custom-coupon-code').style.display = 'none';
        document.getElementById('coupon-display').style.display = 'block';
    }).catch(function(err) {
        console.error('Could not copy text: ', err);
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
      $('.anarc-featured-card-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        // autoplaySpeed: 5000,
        // autoplay: true,
        prevArrow: $('.f-slider-prev-btn'),
        nextArrow: $('.f-slider-next-btn'),
         responsive: [
           {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
         }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
         }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
         }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
         }
      },
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    setHeaderHeight() {
      const headerHeight = document.querySelector('sticky-header');
      document.documentElement.style.setProperty('--header-height', `${headerHeight.offsetHeight}px`);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-only-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
      $('.image-only-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        // speed: 300,
        // infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
         responsive: [
            
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-order"] && !Shopify.designMode) return;
  try {
    
document.getElementById('submit-order-issue').addEventListener('click', function() {
  var orderNumber = document.getElementById('order-number').value.trim();
  var issueDropdown = document.getElementById('order-issue');
  var selectedValue = issueDropdown.value;

  if (orderNumber === '') {
    alert('Please enter your order number.');
    return;
  }
  if (selectedValue === '') {
    alert('Please select an issue.');
    return;
  }
  if (selectedValue === 'cancel-order') {
    window.location.href = '/pages/cancel-order';
  } else {
    document.getElementById('issue-popup').classList.remove('hidden');
  }
});
document.getElementById('close-popup').addEventListener('click', function() {
  document.getElementById('issue-popup').classList.add('hidden');
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strap-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-section-id]');
    if (!wrap) return;

    var tabBtns = wrap.querySelectorAll('[data-tab-btn]');
    var allView = wrap.querySelector('[data-all-view]');
    var sections = wrap.querySelectorAll('[data-section-for]');

    function setActiveTab(tab) {
      tabBtns.forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.tab === tab);
      });
      if (allView) allView.classList.toggle('is-visible', tab === 'all');
      sections.forEach(function (sec) {
        sec.classList.toggle('is-visible', tab !== 'all' && sec.dataset.sectionFor === tab);
      });
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveTab(btn.dataset.tab);
        if (typeof btn.scrollIntoView === 'function') {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    function getCartSectionIds() {
      var ids = [];
      if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
      if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
      if (document.querySelector('cart-notification'))
        ids.push('cart-notification-product', 'cart-notification-button');
      return ids;
    }

    function getSectionInnerHTML(html, selector) {
      selector = selector || '.shopify-section';
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : html;
    }

    function openDawnCart(response) {
      if (!response || !response.sections) return;

      var drawer = document.querySelector('cart-drawer');
      if (drawer && response.sections['cart-drawer']) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        } else {
          drawer.innerHTML = getSectionInnerHTML(response.sections['cart-drawer'], 'cart-drawer');
          if (typeof drawer.open === 'function') drawer.open();
          else drawer.classList.add('animate', 'active');
        }
      }

      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && response.sections['cart-icon-bubble']) {
        bubble.innerHTML = getSectionInnerHTML(response.sections['cart-icon-bubble']);
      }

      var notification = document.querySelector('cart-notification');
      if (notification && typeof notification.renderContents === 'function') {
        notification.renderContents(response);
      }
    }

    function addToCart(container, variantId, btn) {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      fetch(
        window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: getCartSectionIds(),
            sections_url: window.location.pathname,
          }),
        }
      )
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              throw err;
            });
          }
          return r.json();
        })
        .then(function (response) {
          if (btn) {
            btn.textContent = 'Added';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = 'Add';
            }, 1200);
          }
            var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.remove('is-empty');
  }
          openDawnCart(response);
        })
        .catch(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Add';
          }
          alert('Could not add to cart, please try again.');
        })
    }

    wrap.querySelectorAll('[data-product-action]').forEach(function (container) {
      var variantId = container.dataset.variantId;
      var addBtn = container.querySelector('[data-add]');
      if (addBtn && !addBtn.disabled) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          addToCart(container, variantId, addBtn);
        });
      }
    });

    setActiveTab('all');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-gif-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCard(card) {
      var buttons = card.querySelectorAll('[data-wc-target]');
      var items = card.querySelectorAll('[data-wc-index]');
      if (!buttons.length) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-wc-target');

          buttons.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          items.forEach(function (it) {
            it.classList.toggle('is-active', it.getAttribute('data-wc-index') === target);
          });
        });
      });
    }

    function initRoot(root) {
      if (!root) return;
      root.querySelectorAll('[data-wc-card]').forEach(initCard);
    }

    function initAll() {
      document.querySelectorAll('[data-wc-root]').forEach(initRoot);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    // Re-init inside the Shopify theme editor
    document.addEventListener('shopify:section:load', function (e) {
      initRoot(e.target.querySelector('[data-wc-root]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
